import React, { useEffect, useRef, useState } from "react";

import { Burger } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconBrandWhatsapp } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

export const HeaderCategoryList = [
  {
    id: 1,
    title: "비우고\u00A0채우고",
    link: "#about",
  },
  {
    id: 2,
    title: `서비스\u00A0목록`,
    link: "#service",
  },
  {
    id: 3,
    title: "BLOG\u00A0작업사례",
    link: "#blog",
  },
  {
    id: 4,
    title: `고객\u00A0REVIEW`,
    link: "#review",
  },
  {
    id: 5,
    title: "상세\u00A0견적문의",
    link: "#contact",
  },
];

const MHeader = () => {
  const navigate = useNavigate();

  const [opened, { toggle }] = useDisclosure(false);

  const [changeHeaderStyle, setChangeHeaderStyle] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 100) setChangeHeaderStyle(true);
      else setChangeHeaderStyle(false);
    });
    return () => {
      window.removeEventListener("scroll", () => {
        if (window.pageYOffset > 100) setChangeHeaderStyle(true);
        else setChangeHeaderStyle(false);
      });
    };
  }, []);

  const phoneMenuListRef = useRef<HTMLDivElement>(null);
  const burgerIconRef = useRef<HTMLButtonElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    burgerIconRef.current?.addEventListener("click", () => {
      opened
        ? (phoneMenuListRef.current!.style.transform = "translate(0, -120%)")
        : (phoneMenuListRef.current!.style.transform = "translate(0, 0)");
    });
  }, [opened]);

  const menuOnclick = (link: string) => {
    let menuHeight =
      document.querySelector<HTMLDivElement>("#header")!.offsetHeight;

    var location = document.querySelector<HTMLDivElement>(link)!.offsetTop;

    window.scrollY &&
      window.scrollTo({
        top: location - menuHeight + 120,
        behavior: "smooth",
      });
  };

  const phoneMenuOnclick = (link: string) => {
    let menuHeight =
      document.querySelector<HTMLDivElement>("#header")!.offsetHeight;

    var location = document.querySelector<HTMLDivElement>(link)!.offsetTop;

    window.scrollY &&
      window.scrollTo({
        top: location - menuHeight,
        behavior: "smooth",
      });

    toggle();
    phoneMenuListRef.current!.style.transform = "translate(0, -100%)";
  };

  return (
    <header
      style={
        changeHeaderStyle
          ? { backgroundColor: "white" }
          : { backgroundColor: "transparent" }
      }
      className="fixed left-0 top-0 w-full h-fit z-40"
    >
      <div
        ref={headerRef}
        id="header"
        className="relative w-full h-fit px-[calc((100%-var(--container))/5)] 3xl:px-[calc((100%-var(--container))/2)] max-h-20 lg:max-h-32 py-2 lg:py-5 overflow-hidden z-40 transition-all duration-300"
      >
        <div className="relative w-full h-full mx-auto flex justify-between items-center gap-6 xl:gap-16 2xl:gap-20">
          <Burger
            ref={burgerIconRef}
            opened={opened}
            onClick={toggle}
            className="block xl:hidden"
            size="md"
            color={changeHeaderStyle ? "gray" : "white"}
          />
          <div className="relative w-auto h-auto">
            <img
              alt="비우고 채우고 로고"
              onClick={() => navigate("/")}
              className="!relative w-full h-full max-w-md max-h-10 lg:max-h-14 2xl:max-h-16 py-1 object-contain cursor-pointer"
              src={
                changeHeaderStyle ? "/images/logo.webp" : "/images/whiteLogo.webp"
              }
              width={581}
              height={232}
            />
          </div>
          <div className="block xl:hidden relative w-fit h-fit p-1 mx-1 rounded-full">
            <IconBrandWhatsapp
              onClick={() => {
                window.location.href = "tel:010-5229-1437";
              }}
              size={30}
              stroke={1}
              color={changeHeaderStyle ? "gray" : "white"}
            />
          </div>
          <ul
            style={changeHeaderStyle ? { color: "black" } : { color: "white" }}
            className="hidden relative w-fit h-fit text-center xl:flex justify-around items-center justify-items-center gap-14 3xl:gap-32 cursor-pointer"
          >
            {HeaderCategoryList.map((v, i) => (
              <li
                key={i + "pc"}
                onClick={() => menuOnclick(v.link)}
                className="text-center relative w-fit h-fit"
              >
                <p
                  className={
                    i === 0
                      ? "text-base font-black 2xl:text-lg"
                      : "text-base 2xl:text-lg"
                  }
                >
                  {v.title}
                </p>
              </li>
            ))}
          </ul>
          <div className="hidden xl:block relative w-fit h-fit max-w-96 3xl:max-w-none">
            <img
              onClick={() => {
                window.location.href = "tel:010-5229-1437";
              }}
              className="!relative w-full h-full max-h-12 3xl:max-h-14 object-contain cursor-pointer"
              alt="비우고 채우고 전화 상담 010-5229-1437"
              src={"images/rightNum.webp"}
              width={532}
              height={132}
            />
          </div>
        </div>
      </div>
      <div
        ref={phoneMenuListRef}
        className="block xl:hidden fixed top-[50px] left-0 w-full h-full -translate-y-full transition-transform duration-500 z-30"
      >
        <ul className="border-b bg-white text-font">
          {HeaderCategoryList.map((v, i) => (
            <li
              key={i}
              onClick={() => phoneMenuOnclick(v.link)}
              className="border-b py-4 text-center"
            >
              <p className={i === 0 ? "text-base font-black" : "text-base"}>
                {v.title}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
};

export default MHeader;
